/* jslint browser: true,  devel: true */

// require('../node_modules/bootstrap/dist/css/bootstrap.css');
// @import "../../node_modules/bootstrap/dist/css/bootstrap.css";
import { debounce } from "lodash";
import { initCordova, checkMobileAppVersion } from "./utils/cordovaUtils";

import * as Sentry from "@sentry/browser";

import cssVars from "css-vars-ponyfill";
import "ngreact";

require("./scss");
require("./utils/polyfill.js");
require("./utils/routingHelper.js");

window.isMobileApp = !!window.cordova;
window.orgConfig = window.orgConfig || {};

// window.appStorage = window.isMobileApp ? localStorage : sessionStorage;
window.appStorage = localStorage; // TODO make it a setting or sth

window.bootstrap = function() {
  configure();
  bootstrap();
};

function configure() {
  window.app = angular.module("MobiStream", [
    "ngAnimate",
    "ngSanitize",
    "ui.router",
    "ngTouch",
    "hmTouchEvents",
    "backend.jsData",
    "toastr",
    "js-data",
    "oc.lazyLoad",
    "ui.bootstrap",
    "react"
  ]);

  mobileDetect();

  require("./apps/shared/index.js");
  /* apps */
  require("./apps/login/index.js");
  require("./apps/news/index.js");
  require("./apps/container/index.js");
  // require('./apps/news/index.js');

  window.app
    .config([
      "$logProvider",
      "$httpProvider",
      "$animateProvider",
      "$locationProvider",
      "apiProvider",
      function(
        $logProvider,
        $httpProvider,
        $animateProvider,
        $locationProvider,
        apiProvider
      ) {
        // debug logging
        $logProvider.debugEnabled(true);

        $httpProvider.useApplyAsync(true);

        $animateProvider.classNameFilter(
          /(fade|slide|ordered-slide|loading-screen|position-absolute-full|allow-animate)/
        );

        $locationProvider.hashPrefix("");

        apiProvider.server = API_URL;
      }
    ])

    .config([
      "toastrConfig",
      function(toastrConfig) {
        window.angular.extend(toastrConfig, {
          autoDismiss: true,
          containerId: "toast-container",
          get positionClass() {
            return window.isMobile ? "toast-bottom-center" : "toast-top-center";
          },
          preventDuplicates: false,
          preventOpenDuplicates: true
          // TODO none of these settings seem to work, probably because jQuery
          // is required
          // timeOut: 2000,
          // showMethod: 'slideDown',
          // hideMethod: 'fadeOut',
          // showDuration: 500,
          // hideDuration: 500,
        });
      }
    ])
    .run([
      "$rootScope",
      "$state",
      "$location",
      "apiHelper2",
      "apiCall",
      "$q",
      "toastr",
      "setupSearch",
      "setupTopLevelNotif",
      "getEnterprisePlatformConfig",
      "api", // needs to be referenced until we remove js-data completely
      function(
        $rootScope,
        $state,
        $location,
        simpleApi,
        apiCall,
        $q,
        toastr,
        setupSearch,
        setupTopLevelNotif,
        getEnterprisePlatformConfig
      ) {
        if (window.isMobileApp) {
          initCordova(simpleApi, $rootScope);
        }

        let queryParams = {};
        try {
          queryParams = JSON.parse(
            '{"' +
              decodeURI(
                window.location.search
                  .substring(1)
                  .replace(/&/g, '","')
                  .replace(/=/g, '":"')
              ) +
              '"}'
          );
        } catch (e) {
          console.log("A query param passed does not have a value assigned");
        }

        // Handle path being toolBuilder
        if (
          queryParams.path &&
          queryParams.path.includes("toolBuilder") &&
          queryParams.toolId
        ) {
          window.location.hash = `/toolBuilder?mode=render&toolId=${
            queryParams.toolId
          }`;
        } else if (queryParams.path) {
          window.location.hash = queryParams.path;
        }

        $rootScope.isMobileApp = window.isMobileApp;
        $rootScope.canvasOnly = queryParams.canvas;
        $rootScope.orgConfig = window.orgConfig;
        $rootScope.isMobile = window.isMobile;
        $rootScope.initialPath =
          queryParams.path || window.location.hash.substr(1);

        // ***************** GA stuff ****************
        if (window.location.search.indexOf("access_token=") === -1) {
          gtag("js", new Date());
          gtag("config", window.__GA_ID);
        }
        $rootScope.$on("$stateChangeSuccess", function() {
          const path = $location.path();
          if (path.split("/").pop() !== "async") {
            window.gtag("config", window.__GA_ID, {
              page_path: path
            });
          }
        });
        // *******************************************

        // ******* Js-data stuff to eventually remove *************************
        var originalFind = DS.adapters.http.find.bind(DS.adapters.http);
        DS.adapters.http.find = function(resourceConfig, id, options) {
          options.adapter = "http";
          return originalFind(resourceConfig, id, options);
        };

        var originalCacheFind = DS.adapters.cache.find.bind(DS.adapters.cache);
        DS.adapters.cache.find = function(resourceConfig, id, options) {
          options.adapter = "cache";
          return originalCacheFind(resourceConfig, id, options);
        };

        DS.adapters.cache.getIdPath = function(resourceConfig, options, id) {
          return DS.utils.makePath(
            "/",
            options.endpoint || resourceConfig.endpoint,
            id
          );
        };
        // ************************************************

        $rootScope.isBgLoaded = true;
        $rootScope.deviceType = window.isMobile
          ? "mobile"
          : window.isTablet
            ? "tablet"
            : "desktop";
        $rootScope.$state = $state;

        // This may be accessed from some microapps' scopes (e.g. timesheets)
        Object.defineProperty($rootScope, "$stateParams", {
          configurable: true,
          get: function() {
            return $state.params;
          }
        });
        $rootScope.GIT_VERSION = GIT_VERSION;

        $rootScope.setIsPrint = setIsPrint;

        // TODO maybe find a better / more idiomatic way of handling these things
        $rootScope.runPostRender = debounce(() => {
          try {
            window.$('[role="tooltip"]').remove();
            window.$('[data-toggle="tooltip"]').tooltip({ container: "body" });
            window.$('[data-toggle="popover"]').popover({ container: "body" });
          } catch (e) {
            //
          }
          return false;
        }, 200);

        // Handle public routes
        $rootScope.$on("$stateChangeStart", function(
          event,
          toState,
          toParams,
          fromState,
          fromParams
        ) {
          if (toState.allowPublic && !window.interceptor.loadToken()) {
            $rootScope.publicMode = true;
            window.interceptor.token = "NONE";
            window.interceptor.enterprise = { code: toParams.enterprise };
            window.interceptor.userdata = {
              email: "",
              firstName: "Guest",
              lastName: "User"
            };
            $rootScope.auth.confirm();
          }
        });

        $rootScope.auth = {};
        $rootScope.auth.promise = new Promise((resolve, reject) => {
          $rootScope.auth.confirm = resolve;
          $rootScope.auth.fail = reject;
        });

        $rootScope.initReady = $rootScope.auth.promise
          .then(getEnterprisePlatformConfig)
          .then(config => {
            checkMobileAppVersion(config);
            $rootScope.refreshTheme();
            return config;
          });

        $rootScope.initReady.then(() => {
          // Update sentry config
          Sentry.configureScope(scope => {
            scope.setUser({
              email: $rootScope.userdata.email
            });

            scope.setTag("deviceType", $rootScope.deviceType);
            scope.setExtra("orgConfig", $rootScope.orgConfig);
            scope.setExtra("activePosition", $rootScope.activePosition);
          });
        });

        $rootScope.initReady.then(() => {
          if (!$rootScope.publicMode) {
            setupTopLevelNotif($rootScope, apiCall);
          }
        });

        setupSearch();

        $rootScope.shouldShowSideMenu = () =>
          !$rootScope.publicMode &&
          !$rootScope.canvasOnly &&
          $rootScope.appLayout.showSideMenu &&
          !(
            $rootScope.appLayout.hideSideMenuOnDashboard &&
            window.location.hash === "#/"
          );

        $rootScope.shouldShowSearchOnHeader = () =>
          !$rootScope.publicMode &&
          $rootScope.appLayout.showSearchOnHeader &&
          !(
            $rootScope.appLayout.hideHeaderSearchOnDashboard &&
            window.location.hash === "#/"
          );

        $rootScope.getIconClass = icon => {
          const [type, name] = icon.split(":");
          if (type === "ms") {
            // Valid names are:
            // approval, timesheet, staffsearch, news, profile, benefits, leave,
            // payroll, healt
            return `icon-${name}`;
          } else if (type === "material") {
            return "material-icons";
          }
          // TODO maybe add fontawesome, glyphicons or other sets
        };

        $rootScope.getIconContent = icon => {
          const [type, name] = icon.split(":");
          if (type === "material") {
            return name;
          } else {
            return null;
          }
        };

        // TODO maybe move elsewhere
        $rootScope.getAllAttributes = () => {
          if (!$rootScope._allAttributes) {
            // TODO use general api once available
            return simpleApi({
              name: "articleConfig",
              baseEndpoint: "news/$/@/createConfig",
              defaultMethods: "G"
            })
              .get()
              .then(config => {
                $rootScope._allAttributes = config.possibleUserAttributes;
                return $rootScope._allAttributes;
              });
          } else {
            return $q.resolve($rootScope._allAttributes);
          }
        };

        // TODO maybe move elsewhere
        $rootScope.refreshTheme = () => {
          const colorVars = {
            primaryThemeColor: "theme-color",
            headerColor: "header-background",
            headerFontColor: "header-color",
            tileFontColor: "home-tile-color",
            sideMenuPrimaryColor: "menu-background",
            sideMenuFontColor: "menu-color",
            sideMenuSecondaryColor: "submenu-background",
            sideMenuHoverColor: "menu-background-hover",
            sideMenuHoverFontColor: "menu-color-hover",
            sideMenuActiveColor: "menu-background-active",
            sideMenuLineColor: "menu-line",
            searchBoxFontColor: "searchbox-color",
            searchBoxLineColor: "searchbox-input-line",
            searchBoxPlaceholderFontColor: "searchbox-placeholder-color",
            pageBackgroundColor: "page-background-color"
          };

          const imageVars = {
            backgroundImage: "theme-background",
            backgroundImageMobile: "theme-background-mobile",
            primaryLogo: "theme-logo-mini",
            secondaryLogo: "secondary-logo-mini"
            // dashboardLogo: ""
          };

          const theme = $rootScope.theme;
          const vars = [];

          Object.keys(colorVars).forEach(k => {
            if (theme[k]) {
              vars.push(`--${colorVars[k]}: #${theme[k]};`);
            }
          });
          Object.keys(imageVars).forEach(k => {
            if (theme[k]) {
              vars.push(`--${imageVars[k]}: url(${theme[k]});`);
            }
          });

          // TODO maybe add an explicit switch for this
          vars.push(
            `--secondary-logo-display: ${
              theme.secondaryLogo ? "block" : "none"
            }`
          );

          const out = `:root:not(.qwe) {\n${vars.join("\n")}}`;
          console.warn("THEME VARS\n", out);

          const { $ } = window;
          let style = $("head #theme-vars")[0];
          if (!style) {
            style = $("<style id='theme-vars'></style>")[0];
            window.$("head").append(style);
          }
          style.innerHTML = out;

          const varsObj = vars.reduce((obj, rule) => {
            const [prop, val] = rule.split(": ");
            obj[prop] = val;
            return obj;
          }, {});
          console.warn("VARS OBJ", varsObj);

          cssVars({
            watch: true,
            variables: varsObj
            // onlyLegacy: false,
            // preserveVars: true
          });
        };
      }
    ]);

  require("./directives");

  /* services */
  require("./api/js-data");
  require("./services/elementPosition.js");
  require("./services/apiMiddleware.js");
  require("./services/calendar.js");
  require("./services/utils.js");
  require("./services/uiViewAnimate.js");
  require("./services/routeAnimate.js");
  require("./services/ieWarning.js");
  require("./services/consoleRecorder.js");
  require("./services/apiCall.js");
  require("./services/apiHelper.js");
  require("./services/printElement.js");
  require("./services/dataDownload.js");
  require("./services/apiFiles.js");
  require("./services/mimes.js");
  require("./services/copyToClipboard.js");
  require("./services/attributeUtils.js");
  require("./services/avatarSvg.js");
  require("./services/triggerDownload.js");
  require("./services/processIndicator.js");
  require("./services/addressComplete.js");

  /* helpers */
  require("./helpers/setupSearch.js");
  require("./helpers/setupTopLevelNotif.js");
  require("./helpers/enterprisePlatformConfig.js");

  /* filters */
  require("./filters/moment.js");

  function setIsPrint(isPrint) {
    if (isPrint) {
      window.printNative = isMobile
        ? "mobile"
        : isTablet
          ? "tablet"
          : "desktop";
      window.printNow = true;
      window.isMobile = window.isTablet = false;
      window.isDesktop = true;
      document.body.classList.add("print");
      document.body.classList.remove(window.printNative);
      document.body.classList.add("desktop");
    } else {
      window.isMobile = window.printNative === "mobile";
      window.isTablet = window.printNative === "tablet";
      window.isDesktop = window.printNative === "desktop";
      window.printNow = false;
      document.body.classList.remove("print");
      document.body.classList.remove("desktop");
      document.body.classList.add(window.printNative);
    }
  }
}

function bootstrap() {
  angular.bootstrap(document.getElementById("ngApp"), ["MobiStream"], {
    strictDi: true
  });
}

function mobileDetect() {
  var md = new MobileDetect(window.navigator.userAgent);
  window.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (iOS) {
    document.body.classList.add("ios");
  }

  window.isMobile =
    !md.tablet() && (md.phone() || (md.mobile() && md.isPhoneSized()));
  window.isTablet = !isMobile && (md.tablet() || md.mobile());
  window.isDesktop = !isMobile && !isTablet;

  if (location.search === "?printNow") {
    window.printNow = true;
    window.printNative = isMobile ? "mobile" : isTablet ? "tablet" : "desktop";
    window.isMobile = window.isTablet = false;
    window.isDesktop = true;
    document.body.classList.add("print");
  }

  if (window.matchMedia("print").matches) {
    window.printNow = true;
    window.printNative = isMobile ? "mobile" : isTablet ? "tablet" : "desktop";
    window.isMobile = false;
    window.isTablet = false;
    window.isDesktop = true;
  }

  if (isMobile) {
    document.body.classList.add((window.deviceType = "mobile"));
    const updateMobileVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--mobileVh", `${vh}px`);
    };
    window.addEventListener("resize", updateMobileVh);
    updateMobileVh();
  } else if (isTablet) {
    document.body.classList.add((window.deviceType = "tablet"));
  } else {
    document.body.classList.add((window.deviceType = "desktop"));
  }
}

if (window.bootstrapNow) {
  window.bootstrap();
}
// Hook up Sentry
const SENTRY_DSN =
  process.env.SENTRY_DSN ||
  "https://e83294fa079043a8bf4dab9606ab670d@sentry.io/1306436";
const SENTRY_ENV = process.env.SENTRY_ENV || "development";
const SENTRY_RELEASE = process.env.SENTRY_RELEASE || "v-next";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
  release: SENTRY_RELEASE,
  // The following is a strange workaround for a severe
  // freeze/inf.loop/memleak during some error serialization by Sentry
  beforeBreadcrumb: crumb => crumb
});



// WEBPACK FOOTER //
// ./src/main.js